<template>
  <SearchBarColumn
    v-if="helpResults && helpResults.length"
    class="suggestions-right-column help-results"
    title="Help Center"
    :isShowAllVisible="isShowAllVisible"
    :showAllRoute="{
      name: 'helpCenterSearch',
      query: { query },
    }"
  >
    <div v-for="(suggestion, index) in helpResults" :key="suggestion.id">
      <ReloadingRouterLink
        :to="{
          name: 'helpCenterTopic',
          params: {
            page: suggestion.slug,
          },
          query: {
            query,
          },
        }"
        tabindex="0"
        @click="onExit"
      >
        <div class="help-center-title">{{ suggestion.title }}</div>
        <div class="help-center-content" v-html="suggestion.content"></div>
      </ReloadingRouterLink>
    </div>
  </SearchBarColumn>
</template>

<script>
export default { name: 'SearchBarHelpCenter' };
</script>

<script setup>
import { computed, inject } from 'vue';
import ReloadingRouterLink from '@/components/commons/ReloadingRouterLink.vue';
import SearchBarColumn from './SearchBarColumn.vue';

const MAX_RESULTS_VISIBLE = 3;

const props = defineProps({
  query: {
    type: String,
    required: true,
  },
  helpResults: {
    type: Object,
    required: true,
  },
});

const onExit = inject('onExit');

/**
 * Whether to display the "Show All" link
 * It appears this was essentially hard-coded to `true`.
 * TODO: figure out whether this is correct or whether we need this at all.
 */
const isShowAllVisible = computed(() => !!props.helpResults.length || props.helpResults.length > MAX_RESULTS_VISIBLE);
</script>
